import { navigate } from '@reach/router'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import Component from '@cinch/oxd-components/profile-link/src'
import { actions as authActions } from '@cinch/oxd-redux/auth/src'
import { selectors as profileSelectors } from '@cinch/oxd-redux/profile/src'

export const mapStateToProps = (state: any) => {
  const { isComplete, isPending } = profileSelectors.getPredicate(state).fetchStatus
  const { picture, firstName } = profileSelectors.getProfile(state)

  return {
    isPending,
    isAuthenticated: !!(state.oidc && state.oidc.user),
    name: (isComplete && firstName) || '',
    image: (isComplete && picture) || '',
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleLogin: () => dispatch(authActions.login()),
  handleRegister: () => navigate('/sign-up'),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
